import React from 'react';

const Carousel = ({ banner }) => {
    return (
        <div className={
            banner.bannerID == 1
                ?
                "carousel-item active"
                :
                "carousel-item"
        } >
            <a target="_blank" href={banner.url}>
                <div className="carousel-banner" style={{
                    background: `linear-gradient( rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4) ), url('${banner.url}')`
                }}></div>
            </a>
        </div >
    );
};

export default Carousel;